// Company pay period helpers (weekly or fortnightly, any start day, company time zone).
export const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const DAY_FULL = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const TIMEZONES = [
  ["Australia/Sydney", "NSW / ACT"], ["Australia/Melbourne", "VIC"], ["Australia/Brisbane", "QLD"],
  ["Australia/Adelaide", "SA"], ["Australia/Darwin", "NT"], ["Australia/Perth", "WA"], ["Australia/Hobart", "TAS"],
];
export const DEFAULT_PAY = { period: "weekly", start_day: 4, anchor: null, timezone: "Australia/Sydney" };

export const payOf = (company) => ({ ...DEFAULT_PAY, ...(company?.pay || {}) });
export const periodDays = (pay) => (pay.period === "fortnightly" ? 14 : 7);
export const periodWord = (pay) => (pay.period === "fortnightly" ? "fortnight" : "week");

const ymdIn = (date, tz) => new Intl.DateTimeFormat("en-CA", { timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit" }).format(date);

// ISO date (YYYY-MM-DD) of the pay period containing `input` (Date, ISO timestamp or YYYY-MM-DD).
export const periodStartISO = (input, pay) => {
  const ymd = typeof input === "string" && /^\d{4}-\d{2}-\d{2}$/.test(input) ? input : ymdIn(new Date(input), pay.timezone);
  const [y, m, d] = ymd.split("-").map(Number);
  const base = new Date(Date.UTC(y, m - 1, d));
  base.setUTCDate(base.getUTCDate() - ((base.getUTCDay() - pay.start_day + 7) % 7));
  if (periodDays(pay) === 14 && pay.anchor) {
    const weeks = Math.round((base - new Date(`${pay.anchor}T00:00:00Z`)) / (7 * 864e5));
    if (((weeks % 2) + 2) % 2 === 1) base.setUTCDate(base.getUTCDate() - 7);
  }
  return base.toISOString().slice(0, 10);
};

// Roster weeks are always 7 days, starting on the company's pay start day.
export const weekStartISO = (input, pay) => periodStartISO(input, { ...pay, period: "weekly" });
export const weekStartDate = (input, pay) => { const [y, m, d] = weekStartISO(input, pay).split("-").map(Number); return new Date(y, m - 1, d); };
export const weekDayLabels = (pay) => Array.from({ length: 7 }, (_, i) => DAY_NAMES[(pay.start_day + i) % 7]);
export const periodLabel = (pay) => `${DAY_NAMES[pay.start_day]}–${DAY_NAMES[(pay.start_day + 6) % 7]}${pay.period === "fortnightly" ? " fortnightly" : ""}`;
export const inCurrentPeriod = (iso, pay) => !!iso && periodStartISO(iso, pay) === periodStartISO(new Date(), pay);
